import { type ComponentProps, type ComponentType, createElement } from "react";
import type { LooseAutocomplete } from "@/types";

// eslint-disable-next-line @typescript-eslint/no-explicit-any
type ComponentMap = Record<string, ComponentType<any>>;
type FactoryParams<TMap extends ComponentMap, TKey extends keyof TMap = keyof TMap> = TKey extends string
    ? { type: LooseAutocomplete<TKey>; props: ComponentProps<TMap[TKey]> }
    : never;

export default function componentFactory<TMap extends ComponentMap>(contentTypeMap: TMap) {
    function factory({ type, props }: FactoryParams<TMap>) {
        const component = contentTypeMap[type];
        if (!component) return null;

        return createElement(component, props);
    }

    return factory;
}
